module.exports = __webpack_public_path__ + "static/media/top-menu-icon.ef917634.svg";